import React from 'react';
import Modal from 'react-bootstrap/Modal';
import colors from 'styles/colors';
import { linkDaLicitacao } from 'services/market_links';

interface ProductsModalProps {
  showModal: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  products: any;
}

const ProductsModal = (props: ProductsModalProps) => {
  const { showModal, setShowModal, products } = props;

  return (
    <Modal size="lg" show={showModal}>
      <div className="row">
        <div className="col-md-12">
          <div className="modal-content">
            <div className="modal-header" style={{ backgroundColor: colors.$dark_light }}>
              <h5 className="modal-title text-white font-weight-bold">Detalhe do item</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => setShowModal(false)}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="px-3">
              <div className="row mt-4">
                <div className="col-md-12">
                  <p>
                    <b>Nº ConLicitação</b> <br />{' '}
                    <a
                      href={linkDaLicitacao(products?.licitacao_id)}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {products?.licitacao_id}
                    </a>
                  </p>
                </div>
              </div>
            </div>
            <div className="px-3">
              <div className="row mt-4">
                <div className="col-md-12">
                  <span className="font-weight-bold">Objeto:</span>
                  <p>{products?.objeto}</p>
                </div>
              </div>
            </div>
            <div className="px-3">
              <div className="row mt-4">
                <div className="col-md-12">
                  <span className="font-weight-bold">Item:</span>
                  <p>{products?.item_descricao}</p>
                </div>
              </div>
            </div>
            <div className="px-3">
              <div className="row mt-4">
                <div className="col-md-12">
                  <span className="font-weight-bold">Descrição do item:</span>
                  <p>{products?.item_descricao_detalhado}</p>
                </div>
              </div>
            </div>
            <div className="px-3">
              <div className="row mt-4">
                <div className="col-md-12">
                  <span className="font-weight-bold">Vencedor do item:</span>
                  <p>{products?.fornecedor}</p>
                </div>
              </div>
            </div>
            <div className="px-3">
              <div className="row mt-4">
                <div className="col-md-12">
                  <span className="font-weight-bold">Descrição detalhada do item:</span>
                  <p>{products?.item_descricao}</p>
                </div>
              </div>
            </div>
            <div className="px-3">
              <div className="row">
                <div className="col-md-3">
                  <p>
                    <b>Qnt.:</b> <br /> {products?.item_quantidade}
                  </p>
                </div>
                <div className="col-md-3">
                  <p>
                    <b>Un. Fornecimento:</b> <br /> {products?.item_unidade}
                  </p>
                </div>
                <div className="col-md-3">
                  <p>
                    <b>Valor Unitário:</b> <br />{' '}
                    {products?.item_valor_unitario
                      ? products?.item_valor_unitario.toLocaleString('pt-br', {
                          style: 'currency',
                          currency: 'BRL',
                        })
                      : '-'}
                  </p>
                </div>
                <div className="col-md-3">
                  <p>
                    <b>Valor Total:</b> <br />{' '}
                    {products?.item_valor_total
                      ? products?.item_valor_total.toLocaleString('pt-br', {
                          style: 'currency',
                          currency: 'BRL',
                        })
                      : '-'}
                  </p>
                </div>
              </div>
            </div>
            <div className="px-3">
              <div className="row">
                <div className="col-md-4">
                  <p>
                    <b>Marca:</b> <br /> {products?.marca_item_ofertado}
                  </p>
                </div>
                <div className="col-md-4">
                  <p>
                    <b>Fabricante:</b> <br /> {products?.fabricante_item_ofertado}
                  </p>
                </div>
                <div className="col-md-4">
                  <p>
                    <b>Modelo:</b> <br /> {products?.modelo_item_ofertado}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              data-dismiss="modal"
              onClick={() => setShowModal(false)}
            >
              fechar
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};
export default ProductsModal;
